export default {"src":"/_next/static/media/dairy.8e9b3ba4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};